module.exports = __webpack_public_path__ + "fdf695da004243c28c0ad62cdb3c2dee.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=2400!./src/components/cover/teaser-dark.png?size=2400w
// module id = 42
// module chunks = 1